import { HISTORY_TOPUP, SELECTED_TOPUP, SUBMIT_TOPUP, TOPUP_INITIAL_STATE } from "./type";

const initiate = {
    histories: [],
    currentTab: 0,
    initialFetch: true,

    // Dashboard
    topUpData: [],
    selectedTopUp: {},
    showTopUp: false,
    submit: false,
}

const TopUpReducer = (state = initiate, action) => {
    switch (action.type) {
        case TOPUP_INITIAL_STATE:
            return {
                ...state,
                ...action.payload,
            };
        case SELECTED_TOPUP:
            return {
                ...state,
                ...action.payload,
            };
        case SUBMIT_TOPUP:
            return {
                ...state,
                ...action.payload,
            };
        case HISTORY_TOPUP:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}

export default TopUpReducer;